import { render } from "./mobilemenu.vue?vue&type=template&id=4d22ea82"
const script = {}
script.render = render

export default script